import { WORKFLOW_METIN } from './metin/workflow';
import { durumAdi } from './metin/ortak';

/**
 * Uçtan gelen durum geçişi ve sürüm çakışması hataları (`ILLEGAL_TRANSITION`, `VERSION_CONFLICT`)
 * İngilizce ve ham enum kodlarıyla gelir. Ekrana yazılacak cümle burada Türkçeye çevrilir; uç
 * sözleşmesi (kod ve ileti) değişmez, testler ve destek kayıtları kodu görmeye devam eder.
 */

const GECIS_DESENI = /^(\w+) cannot move from (\w+) to (\w+)$/;
const SURUM_DESENI = /^(\w+) was modified by someone else/;

function varlik(kod: string): string {
  return WORKFLOW_METIN.varlik[kod] ?? kod;
}

export function gecisHatasiMetni(code: string | undefined, ileti: string, reason?: string): string | null {
  if (reason === 'STATE_TRANSITION_NOT_ALLOWED') {
    const destek = /cannot move from (\w+) to (\w+)/.exec(ileti);
    return destek ? WORKFLOW_METIN.genel.gecisYapilamaz('Destek talebi', durumAdi(destek[1] ?? ''), durumAdi(destek[2] ?? '')) : WORKFLOW_METIN.genel.gecisReddedildi;
  }
  if (code === 'ILLEGAL_TRANSITION') {
    const eslesme = GECIS_DESENI.exec(ileti.trim());
    if (!eslesme) return WORKFLOW_METIN.genel.gecisReddedildi;
    const [, ad = '', onceki = '', sonraki = ''] = eslesme;
    if (onceki === sonraki) return WORKFLOW_METIN.genel.gecisZatenYapilmis(varlik(ad), durumAdi(onceki));
    return WORKFLOW_METIN.genel.gecisYapilamaz(varlik(ad), durumAdi(onceki), durumAdi(sonraki));
  }
  if (code === 'VERSION_CONFLICT') {
    const eslesme = SURUM_DESENI.exec(ileti.trim());
    return eslesme ? WORKFLOW_METIN.genel.surumCakisti(varlik(eslesme[1] ?? '')) : WORKFLOW_METIN.genel.surumCakistiGenel;
  }
  return null;
}
